import React from 'react';
import { FormattedNumber } from 'react-intl';
import { Table, Dropdown } from 'semantic-ui-react';
import { find, result } from 'lodash';
import { RETURN_STATUS } from '../../constants';
import { formatCoverageProduct } from '../../utilities/productUtil';

const ListRow = actionHandler => returnInvoice => {
  const rowMenuOptions = [
    { key: 1, text: 'Edit', disabled: true, value: 'Edit' },
    { key: 2, text: 'Status History', value: 'Status History' },
    { key: 3, text: 'Reinstate Return', value: 'Reinstate Return' },
    { key: 5, text: 'Vehicle Status Tracker', value: 'Vehicle Status Tracker' },
  ];

  const {
    id,
    vin,
    returnInitiatedAt,
    expirationDate,
    returningUsername,
    cancellingUsername,
    cancelledAt,
    invalidatedAt,
    reasonForReturn,
    locationInitials,
    returnLocationInitials,
    odometer,
    status,
    purchasePrice,
    dealerNumber,
    productName,
    kind,
    daysSelected,
    milesSelected,
  } = returnInvoice;

  const isInvalidated = Boolean(invalidatedAt);

  const getStatusDisplay = () => {
    if (isInvalidated) return 'Invalidated';
    return result(find(RETURN_STATUS, ['value', status]), 'text') || status;
  };

  const currencyProps = price => {
    return {
      currency: 'USD',
      style: 'currency',
      minimumFractionDigits: 0,
      value: price,
    };
  };

  const handleActionChange = (e, { value }) => {
    e.preventDefault();
    actionHandler(value, returnInvoice);
  };

  return (
    <Table.Row key={id}>
      <Table.Cell>{id}</Table.Cell>
      <Table.Cell>{vin}</Table.Cell>
      <Table.Cell>{dealerNumber}</Table.Cell>
      <Table.Cell>
        {returnLocationInitials || locationInitials}
      </Table.Cell>
      <Table.Cell>{odometer}</Table.Cell>
      <Table.Cell>
        {React.createElement(FormattedNumber, currencyProps(purchasePrice))}
      </Table.Cell>
      <Table.Cell>{returnInitiatedAt}</Table.Cell>
      <Table.Cell>{expirationDate}</Table.Cell>
      <Table.Cell>
        {getStatusDisplay()}
      </Table.Cell>
      <Table.Cell>{reasonForReturn}</Table.Cell>
      <Table.Cell data-testid='product-cell'>
        {formatCoverageProduct({
          productName, kind, daysSelected, milesSelected,
        })}
      </Table.Cell>
      <Table.Cell>{returningUsername}</Table.Cell>
      <Table.Cell>{cancellingUsername}</Table.Cell>
      <Table.Cell>{isInvalidated ? invalidatedAt : cancelledAt}</Table.Cell>
      <Table.Cell>
        <Dropdown
          text='Actions'
          options={rowMenuOptions}
          icon='ellipsis horizontal'
          onChange={handleActionChange}
          inline
          item
          selectOnBlur={false}
          value={null}
        />
      </Table.Cell>
    </Table.Row>
  );
};

export default ListRow;
